import dashboardComponentRegistry from './dashboardComponentRegistry'

export function sanitizeDataField(value) {
  if (value === null || value === undefined) {
    return value
  }
  return String(value).replace(/\s+/g, '-')
}

function declaresInstanceProp(component) {
  if (!component) {
    return false
  }
  if (component.props && component.props.instance) {
    return true
  }
  return Array.isArray(component.mixins) && component.mixins.some(declaresInstanceProp)
}

export function childDataField(node, child, index, prefix) {
  const childComponent = dashboardComponentRegistry[child.type]
  const isSelfManaged = child.children || declaresInstanceProp(childComponent)
  if (isSelfManaged) {
    return undefined
  }
  const parentId = node && ((node.props && node.props.id) || node.id)
  const instance = (child.props && child.props.instance) ||
    (node && node.props && node.props.instance) ||
    parentId || ''
  const scope = prefix ? `${instance}-${prefix}` : instance
  return sanitizeDataField(`${scope}-${index}`)
}
